module.exports = __webpack_public_path__ + "img/Bengaluru_cover.3e8c9602.jpg";